export default Object.freeze({
  Pending: 1,
  Approved: 2,
  Denied: 3,
});
